import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Grid, Button } from '@material-ui/core'

import { Card } from 'components/layout/Card'
import { SingleFileUploadField } from 'components/form/SingleFileUploadField'
import { FormikDropdownField } from 'components/form/Dropdown'
import { Separator } from 'components/layout/Separator'


export default function AdminBIImportForm(props) {
  const { formik_props, table_name_options } = props

  return (
    <Grid container spacing={ 2 }>
      <Grid item xs={ 12 } md={ 4 }>
        <Card
          title="Upload File"
          content={
            <>
              <SingleFileUploadField
                name="bi_import_file"
                dropzonePlaceholder="Upload the file containing BI data"
                buttonPlaceholder="BI Import File"
                formik_props={ formik_props }
              />
              <Separator height={15} />
              <FormikDropdownField
                name="table_name"
                formik_props={ formik_props }
                options={ table_name_options }
                label="Table Name"
                helperText={ "Please select a table to upload to" }
              />
              <Separator height={25} />
            </>
          }      
        />
      </Grid>  
    </Grid>
  )
}
